module.exports = __webpack_public_path__ + "static/scale-model-of-san-diego-zoo-safari-park-in-escondido-california-3fbaac714eb8da9869fcbd56bd4c0a04.png";